import { ConfirmDialog, ConfirmDialogProps } from "primereact/confirmdialog";
import React from "react";

interface ThemeConfirmDialogProps extends ConfirmDialogProps {}
const ThemeConfirmDialog: React.FC<ThemeConfirmDialogProps> = ({ ...rest }) => {
  return <ConfirmDialog {...rest} />;
};

export default ThemeConfirmDialog;
